module.exports = __webpack_public_path__ + "static/media/teach-coding-easy.049f58bd.webp";